<template>
  <div>
    <div v-if="value === 'GOOD'" class="answer-badge -GOOD">
      <BaseIcon icon="thumbsUp" :size="16" />
    </div>
    <div v-if="value === 'BAD'" class="answer-badge -BAD">
      <BaseIcon icon="thumbsDown" :size="16" />
    </div>
    <div v-if="value === 'SKIP'" class="answer-badge -SKIP">
      <BaseIcon icon="chat" :size="16" />
    </div>

    <div v-if="value === '1'" class="answer-badge -v1">
      1
    </div>
    <div v-if="value === '2'" class="answer-badge -v2">
      2
    </div>
    <div v-if="value === '3'" class="answer-badge -v3">
      3
    </div>
    <div v-if="value === '4'" class="answer-badge -v4">
      4
    </div>
    <div v-if="value === '5'" class="answer-badge -v5">
      5
    </div>
  </div>
</template>

<script setup>
import BaseIcon from '@/components/BaseIcon.vue';

defineProps({
  value: {
    type: String,
    default: null,
  },
});
</script>

<style>
.answer-badge {
  min-width: 32px;
  width: 32px;
  height: 32px;
  border-radius: var(--border-radius-sm);
  background-color: var(--gray-800);
  color: var(--white);
  display: flex;
  align-items: center;
  justify-content: center;

  /* Trio */
  &.-GOOD {
    background-color: var(--green);
  }
  &.-BAD {
    background-color: var(--red);
  }
  &.-SKIP {
    background-color: var(--gray-800);
  }

  /* Spectrum */
  &.-v1, &.-v2 {
    background-color: var(--green);
  }
  &.-v3 {
    background-color: var(--red);
  }
  &.-v4, &.-v5 {
    background-color: var(--red);
  }
}
</style>
